/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as IntegratorsRouteImport } from './routes/integrators'
import { Route as AffiliatesRouteImport } from './routes/affiliates'
import { Route as IndexRouteImport } from './routes/index'

const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const PricingRoute = PricingRouteImport.update({
  id: '/pricing',
  path: '/pricing',
  getParentRoute: () => rootRouteImport,
} as any)
const IntegratorsRoute = IntegratorsRouteImport.update({
  id: '/integrators',
  path: '/integrators',
  getParentRoute: () => rootRouteImport,
} as any)
const AffiliatesRoute = AffiliatesRouteImport.update({
  id: '/affiliates',
  path: '/affiliates',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/affiliates': typeof AffiliatesRoute
  '/integrators': typeof IntegratorsRoute
  '/pricing': typeof PricingRoute
  '/privacy': typeof PrivacyRoute
  '/terms': typeof TermsRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/affiliates': typeof AffiliatesRoute
  '/integrators': typeof IntegratorsRoute
  '/pricing': typeof PricingRoute
  '/privacy': typeof PrivacyRoute
  '/terms': typeof TermsRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/affiliates': typeof AffiliatesRoute
  '/integrators': typeof IntegratorsRoute
  '/pricing': typeof PricingRoute
  '/privacy': typeof PrivacyRoute
  '/terms': typeof TermsRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/affiliates'
    | '/integrators'
    | '/pricing'
    | '/privacy'
    | '/terms'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/affiliates' | '/integrators' | '/pricing' | '/privacy' | '/terms'
  id:
    | '__root__'
    | '/'
    | '/affiliates'
    | '/integrators'
    | '/pricing'
    | '/privacy'
    | '/terms'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AffiliatesRoute: typeof AffiliatesRoute
  IntegratorsRoute: typeof IntegratorsRoute
  PricingRoute: typeof PricingRoute
  PrivacyRoute: typeof PrivacyRoute
  TermsRoute: typeof TermsRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pricing': {
      id: '/pricing'
      path: '/pricing'
      fullPath: '/pricing'
      preLoaderRoute: typeof PricingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/integrators': {
      id: '/integrators'
      path: '/integrators'
      fullPath: '/integrators'
      preLoaderRoute: typeof IntegratorsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/affiliates': {
      id: '/affiliates'
      path: '/affiliates'
      fullPath: '/affiliates'
      preLoaderRoute: typeof AffiliatesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AffiliatesRoute: AffiliatesRoute,
  IntegratorsRoute: IntegratorsRoute,
  PricingRoute: PricingRoute,
  PrivacyRoute: PrivacyRoute,
  TermsRoute: TermsRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
